module.exports = __webpack_public_path__ + "static/media/APP_OfficeWorm_152x174_3.7eb5d22b.png";